import { Dispatch, SetStateAction, useEffect } from "react";
import { attrOutline, attribute } from "../../../types/attributeType";
import { ViewType, isViewTypeForSecond } from "../../../types/viewType";
import FilterCondTag from "./FilterCondTag";
import ResetFilterCondTag from "./ResetFilterCondTag";
import styles from "./filterCondTagsArea.module.scss";

type Props = {
  attrOutlineList: Array<attrOutline>;
  handleChangeAttribute: (label: string, attr: attribute) => void;
  viewType: ViewType;
  setViewType: Dispatch<SetStateAction<ViewType>>;
};

const FilterCondTagsArea = ({
  attrOutlineList,
  handleChangeAttribute,
  viewType,
  setViewType,
}: Props) => {
  const attrs = attrOutlineList
    .map((ao) =>
      ao.attributes.map((attr) => ({
        parentLabel: ao.label,
        attr,
      }))
    )
    .flat();

  const resetAttrs = () => {
    for (const a of attrs) {
      handleChangeAttribute(a.parentLabel, a.attr);
    }
  };

  const isViewTypeNormal =
    viewType === "NORMAL" || viewType === "SECOND_NORMAL";

  const reset = () => {
    setViewType(isViewTypeForSecond(viewType) ? "SECOND_NORMAL" : "NORMAL");
    resetAttrs();
  };

  // NOTE: reset 時に NORMAL に戻した後、NORMAL の filter 条件も reset するため
  useEffect(() => {
    if (isViewTypeNormal && attrs.length !== 0) resetAttrs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewType]);

  if (attrs.length === 0 && isViewTypeNormal) return <></>;

  let tagCount = attrs.length;
  if (!isViewTypeNormal) tagCount++;

  return (
    <div className="flex justify-between items-center bg-[#000000cc] mx-[calc(50%_-_50vw)] px-[calc(50vw_-_50%)]">
      <div className={styles.filterCondTagsWrapper}>
        <ViewTypeTag viewType={viewType} setViewType={setViewType} />
        {attrs.map((a) => (
          <FilterCondTag
            key={a.attr.label}
            text={a.attr.content}
            close={() => handleChangeAttribute(a.parentLabel, a.attr)}
          />
        ))}
      </div>
      <ResetFilterCondTag count={tagCount} reset={reset} />
    </div>
  );
};

const ViewTypeTag = ({
  viewType,
  setViewType,
}: {
  viewType: ViewType;
  setViewType: Dispatch<SetStateAction<ViewType>>;
}) => {
  const close = () =>
    setViewType(isViewTypeForSecond(viewType) ? "SECOND_NORMAL" : "NORMAL");

  switch (viewType) {
    case "NORMAL":
    case "SECOND_NORMAL":
      return <></>;
    case "MYGENE":
    case "SECOND_MYGENE":
      return (
        <FilterCondTag key="my-collection" text="MY COLLECTION" close={close} />
      );
    case "EDITED":
    case "SECOND_EDITED":
      return <FilterCondTag key="edited" text="EDITED" close={close} />;
    default:
      const unexpected: never = viewType;
      throw Error(`${unexpected} is not viewType`);
  }
};

export default FilterCondTagsArea;
